import { useState } from "react";
import { Redirect } from "react-router-dom";

import { useAuth } from "../context/auth";
import axios from "axios";

import styles from "./styles.module.scss";

function Login(props) {
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [isError, setIsError] = useState(false);
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const { setAuthTokens } = useAuth();

  const referer = props.location?.state?.referer || "/";

  function toFormData(data) {
    const tmp = new FormData();
    Object.keys(data).forEach((key) => {
      tmp.append(key, data[key]);
    });
    return tmp;
  }

  function postLogin(e) {
    e.preventDefault();
    //console.log(process.env.REACT_APP_LOGIN_URL);
    axios
      .post(
        process.env.REACT_APP_LOGIN_URL,
        toFormData({
          username,
          password,
        })
      )
      .then((result) => {
        if (result.status === 200) {
          setAuthTokens(result.data);
          setLoggedIn(true);
          // setAuthTokens(result.data);
        } else {
          setIsError(true);
        }
      })
      .catch(() => {
        setIsError(true);
      });
  }

  if (isLoggedIn) {
    return <Redirect to={referer} />;
  }

  return (
    <div className={styles.limiter}>
      <div className={styles.containerLogin100}>
        {isError && (
          <span style={{ color: "red" }}>
            The username or password provided were incorrect!
          </span>
        )}
        <div className={styles.wrapLogin100}>
          <form autoComplete="off" className={styles.loginForm}>
            <div className={styles.logo}>
              <img
                width={100}
                src={process.env.REACT_APP_LOGO}
                alt="Logo GENI6TM"
              />
            </div>
            <div className={styles.wrapInput100}>
              <input
                type="text"
                className={styles.inputW}
                placeholder="Username"
                autoComplete="off"
                value={username}
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
              />
            </div>
            <div className={styles.wrapInput100}>
              <input
                type="password"
                className={styles.inputW}
                placeholder="Password"
                autoComplete="off"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </div>
            <p>
              <a href="/LostPassword" class="align-left">
                Mot de passe oublié?
              </a>
            </p>
            <div className={styles.containerFormLoginBtn}>
              <button onClick={postLogin} className={styles.login100Btn}>
                S'identifier
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className={styles.footer}>
        <div>
          <img width="150" src="img/ITGB_PNG.png" alt="Logo GBit" />
          <p>
            Copyright © 2014-2024{" "}
            <a target="blanc" href="https://it-gb.com/">
              SARL ITGB
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
